import api from 'shared/api'
import { setSearchQueryParam } from 'shared/helpers'

const basePageSize = 20

// Get License Manager User-Groups list
export const fetchUserGroups = (
  companyId,
  managerId,
  accountId,
  page = 0,
  query,
  queryType,
  orderBy,
  pageSize = basePageSize
) => {
  const accountIdParam = accountId ? `&customer_account=${accountId}` : ''
  const queryUrl = setSearchQueryParam(query, queryType)
  const orderUrl = orderBy
    ? `&order_by=${orderBy.map(orderType => `${orderType.desc ? '-' : ''}${orderType.id}`)}`
    : ''
  const url = `/api/v1/license-user-groups/?company=${companyId}&license_managers__id=${managerId}${accountIdParam}&limit=${pageSize}&offset=${page *
    pageSize}${orderUrl}${queryUrl}`
  return api.get(url)
}

// Get License Manager orders list
export const fetchOrders = (
  companyId,
  managerId,
  accountId,
  page = 0,
  query,
  queryType,
  orderBy,
  pageSize = basePageSize
) => {
  const accountIdParam = accountId ? `&customer__account=${accountId}` : ''
  const queryUrl = setSearchQueryParam(query, queryType)
  const orderUrl = orderBy
    ? `&order_by=${orderBy.map(orderType => `${orderType.desc ? '-' : ''}${orderType.id}`)}`
    : ''
  const url = `/api/v1/orders/?company=${companyId}&any__license_managers__id=${managerId}${accountIdParam}&limit=${pageSize}&offset=${page *
    pageSize}${orderUrl}${queryUrl}`
  return api.get(url)
}

// get License Manager licenses list
export const fetchLicenses = (
  companyId,
  managerId,
  accountId,
  page = 0,
  query,
  queryType,
  orderBy,
  pageSize = basePageSize
) => {
  const accountIdParam = accountId ? `&order__customer_account=${accountId}` : ''
  const queryUrl = setSearchQueryParam(query, queryType)
  const orderUrl = orderBy
    ? `&order_by=${orderBy.map(orderType => `${orderType.desc ? '-' : ''}${orderType.id}`)}`
    : ''
  const url = `/api/v1/licenses/?company=${companyId}&any__order__license_managers__id=${managerId}${accountIdParam}&limit=${pageSize}&offset=${page *
    pageSize}${orderUrl}${queryUrl}`
  return api.get(url)
}
